import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function DicasEnvioInternacional() {
  return <ArticleLayout article={newArticles[6]} />;
}